import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.css'],
    standalone: false
})
export class SearchFieldComponent implements OnInit {
  @Output() search = new EventEmitter();

  @Output() searchQueryChange = new EventEmitter();

  private query: string;

  @Input()
  get searchQuery() {
    return this.query;
  }

  set searchQuery(val) {
    this.query = val;
    this.searchQueryChange.emit(this.query);
  }

  constructor() {
  }

  ngOnInit() {
  }
}
